import { RolePrivilegeStoreType } from '@shared/types/store/role-privilege.types';
import { create } from 'zustand';

export const rolePrivilegeStore = create<RolePrivilegeStoreType>((set) => ({
  rolePrivileges: null,
  updateRolePrivileges: (rolePrivileges) => set({ rolePrivileges }),
  loggedIn: false,
  setLoggedIn: () => set({ loggedIn: true }),
}));
